module.exports = __webpack_public_path__ + "img/supplyOne-02.caea4d29.jpg";